// The Return schemas still describe the legacy externalIntegrationIds field
// because its stored data stays. Only those schemas may import this file; an
// ESLint rule blocks every other import.

/**
 * @deprecated Storage only. Describes the values already stored in the legacy
 * `externalIntegrationIds` Return field, which nothing reads or writes any
 * more. Use `CreateExternalIntegrationIdProvider` for RMA integration IDs.
 */
export enum ExternalIntegrationIdProviders {
  AIMS360 = "aims360",
  APPAREL_MAGIC = "apparelmagic",
  BLUE_CHERRY = "bluecherry",
  BRIGHTPEARL = "brightpearl",
  CIN7_OMNI = "cin7omni",
  CLOUDX = "cloudx",
  CONTROLPORT = "controlport",
  EXTENSIV = "extensiv",
  FLEXPORT = "flexport",
  GLOBALE = "globale",
  HAPPY_RETURNS = "happyreturns",
  NETSUITE = "netsuite",
  ODOO = "odoo",
  SELLERCLOUD = "sellercloud",
  SFOM = "sfom",
  SHIPBOB = "shipbob",
  SHIPEDGE = "shipedge",
  SHIPHERO = "shiphero",
  SHIPMONK = "shipmonk",
  TRACKSTAR = "trackstar",
  RYDER = "ryder",
  RETURNBEAR = "returnbear",
  BLUEYONDER = "blueyonder",
  INMAR = "inmar",
  DEPOSCO = "deposco",
  INDIGO8 = "indigo8",
  ASTRO = "astro",
  MASONHUB = "masonhub",
  MINTSOFT = "mintsoft",
  ECWID = "ecwid",
  LINNWORKS = "linnworks",
}

/**
 * @deprecated Storage only. Describes the values already stored in the legacy
 * `externalIntegrationIds` Return field. Use `CreateExternalIntegrationIdType`.
 */
export enum ExternalIntegrationIdTypes {
  // Primary return document
  RMA = "rma",

  // Return label identifiers, which may be shared by multiple bags
  RETURN_BARCODE = "return_barcode",

  // Support documents
  SUPPORT_CASE = "support_case",

  // Financial documents
  CASH_REFUND = "cash_refund",
  CREDIT_MEMO = "credit_memo",
  REFUND = "refund",
  SALES_CREDIT = "sales_credit",
  SALES_CREDIT_PAYMENT = "sales_credit_payment",

  // Fulfillment documents
  RECEIPT = "receipt",
  SALES_ORDER = "sales_order",

  // Vendor documents
  VENDOR_RETURN_AUTHORIZATION = "vendor_return_authorization",

  // Physical package identifiers
  BOX = "box",
  BOX_BARCODE = "box_barcode",
}
